<template>
  <v-row justify="center">
    <v-col md="6">
      <v-expansion-panels
        flat
        multiple
      >
        <template v-for="(item, index) in countryWorkload">
          <CountryWorkloadFormCategory
            :key="index"
            :item="item"
            :path="'[' + index + ']'"
            :allow-group="true"
            @addNewWorkload="addNewWorkload"
            @save="onSave"
            @remove="onRemove(index)"
          />
        </template>
      </v-expansion-panels>

      <v-btn
        class="mt-5"
        color="success"
        @click="addNewWorkload"
      >
        {{ $t('Add Category') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        name: "CountryWorkloadForm",

        components: {
            'CountryWorkloadFormCategory': () => import('@/components/workload/CountryWorkloadFormCategory'),
        },

        data() {
            return {
                editing: false,

            }
        },

        computed: {
            ...mapGetters('countries', [
                'country'
            ]),

            countryWorkload() {
                return this.country?.workload || []
            },

            // workloadListItems() {
            // let items = [];

            // let genItem = ({text = '', header = false, divider = false, disabled = false}) => {
            //     return {
            //         text: text,
            //         value: text,
            //         disabled: disabled,
            //         divider: divider,
            //         header: header
            //     }
            // };

            // for (let category of this.equipmentListItems_) {
            //     items.push(genItem({header: category.categoryName}));
            //     for (let item of category.items) {
            //         let disabled = false;
            //         if (this.countryEquipment.findIndex(e => e.inventory === item) !== -1) {
            //             disabled = true;
            //         }
            //         items.push(genItem({text: item, disabled}))
            //     }
            //     items.push(genItem({divider: true}));
            //
            // }

            // return items;
            // }
        },

        methods: {
            ...mapActions('countries', {
                updateCountry: 'update',
                getCountry: 'getOne'
            }),

            ...mapMutations('countries', [
                'setCountry'
            ]),

            ...mapMutations([
                'setGlobalLoading'
            ]),

            addNewWorkload() {
                if (!this.country.workload) {
                    this.country.workload = [{
                        type: 'category',
                        name: '',
                        children: []
                    }];
                } else {
                    this.country.workload.push({
                        type: 'category',
                        name: '',
                        children: []
                    })
                }
            },

            async onSave() {
                let updateData = {
                    id: this.country.id,
                    data: {
                        workload: this.country.workload
                    },
                    getOne: true
                };

                this.setGlobalLoading(true);

                try {
                    let res = await this.updateCountry(updateData);
                    this.setCountry(res[0])
                } catch (e) {
                    console.error(e)
                } finally {
                    this.setGlobalLoading(false);
                }
            },

            async onRemove(index) {
                this.country.workload.splice(index, 1);
                this.onSave()
            }

        }


    }
</script>

<style scoped>

</style>
